import { ComponentDefaultMessageVO } from '@repo/types'
import { fetcher } from '../utils'

export default async (id: string): Promise<ComponentDefaultMessageVO> =>
  fetcher(`/api/defaultMessage/${id}`, 'GET', undefined)
